import * as auth from "./auth";
import {STORAGE_API_URL} from "../constants/api";

/**
 * Filters object keys
 * @param {object} object - object to be filtered by keys
 * @param {array} keys - list of keys for filtering
 * @returns {object} - filtered object
 */
export function filter(object, keys) {
  return Object.keys(object)
    .filter((key) => keys.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key];
      return obj;
    }, {});
}

/**
* Encodes string into a base64 string, able to manage special german char
* @param {string} str - string that might contain umlaut
* @returns {string} - base64 string with proper special german char management
* first we use encodeURIComponent to get percent-encoded UTF-8,
* then we convert the percent encodings into raw bytes which
* can be fed into btoa.
*/
export function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    (match, p1) => {
      return String.fromCharCode(`0x${p1}`);
    }));
}

/**
* Decodes a base64 string into a regular string
* @param {string} str - base64 string
* @returns {string} - regular string with proper special german char
*  Going backwards: from bytestream, to percent-encoding, to original string.
*/
export function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).split('')
    .map((char) => {
      return `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`;
    })
    .join(''));
}

/**
 * Hashes a string and return it's hex representation
 * @param {string} str - input string
 * @returns {string} hashed string
 */
export function hash(str) {
  return Array.from(btoa(str))
    .map((char) => char.charCodeAt(0).toString(16))
    .join('');
}

/**
 * Gets image url from Storage Microservice based on hash
 * @param {string} imageHash - image hash
 * @returns {string} image url
 */
export function getStorageImageUrl(imageHash) {
  return `${STORAGE_API_URL}/redirect?hash=${imageHash}&token=${auth.getToken()}`;
}

export const isDeviceMobile = () => {
  const { userAgent } = navigator;
  const pattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;

  return pattern.exec(userAgent) !== null;
};
